const formatZip = (value) => {
    if (value !== undefined) {
        const val = value.replace(/\D/g, "");
        if (val.length === 5) {
            value = val;
        }
        return val;
    }
    return "";
};

export default formatZip;
